import Entity from '../entity'
export default class Regalo extends Entity<number>{
    articulo: string;
    referenciaCliente: string;
    referenciaOdoo: string;
    descripcionDC: string;
    campanaId: number;

}